<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import TradingHeading from '@/components/Trading/TradingHeading.vue'
import { useGlobalSeoMetaHandler } from '@/services/seoGlobalService'
import {
  fetchTermsAndConditionsStore, useSeo, useSeoIndexFollow,
  useTermsAndConditionsData
} from '@/services/termsAndConditionsService'

interface HeroSection {
  title: string
  description: string
}

interface ContentItem {
  title: string
  text: string
}

interface Fields {
  educationtemplateshero: HeroSection
  sub_title: string
  sub_description: string
  content_list: ContentItem[]
}

const fields = ref<Fields>()

const route = useRoute()

onMounted(async () => {
  // await fetchTermsAndConditionsStore(route?.name as string, 'terms_and_conditions')
    await fetchTermsAndConditionsStore(route?.params.slug as string, 'terms_and_conditions')
  fields.value = useTermsAndConditionsData().value
  useSeo()
  useGlobalSeoMetaHandler(useSeoIndexFollow())
})
</script>
<template>
  <TradingHeading
    :withBreadcrumbs="false"
    :title="fields?.educationtemplateshero?.title"
    :subTitle="fields?.educationtemplateshero?.description"
  ></TradingHeading>
  <div class="flex flex-col items-center w-full lg:py-40 lg:placeholder-yellow-400">
    <div class="justify-center w-full max-w-[1200px]">
      <h2 class="relative text-center z-5 lg:h2-bold h3-bold">
        {{ fields?.sub_title }}
      </h2>
      <p class="relative z-10 text-center text-gray-600 lg:mb-20">
        {{ fields?.sub_description }}
      </p>
    </div>
    <div
      :key="index"
      v-for="(item, index) in fields?.content_list"
      class="px-[10px] lg:px-0 py-5 lg:items-start items-center lg:block flex flex-col w-full max-w-[1200px]"
    >
      <h3 class="lg:h3-bold h5-bold">{{ item.title }}</h3>
      <div v-html="item.text" class="w-full mt-5 butter-wysiwyg"></div>
    </div>
  </div>
</template>
